import React from 'react'

function CustomerManagementFeatureBox1() {
    return (
        <div className='homebox2main' id='feature-box1'>
            <div className='container'>
                <div className='homebox2'>
                    <div className='homebox2-left'>
                        <img src="/img-engage2.webp" alt="hero-img" />
                    </div>
                    <div className='homebox2-right'>
                        <span>Customer Management</span>
                        <h2>Build Stronger Customer Relationships</h2>
                        <p>Manage customer information, engagement, and loyalty activities through a centralized and easy-to-use customer management system. Keep track of customer interactions, preferences, and participation to deliver a more personalized and efficient experience.</p>
                        <h5>Smart Tools for Better Customer Experience</h5>
                        <ul>
                            <li>Store and manage customer details securely in one platform</li>
                            <li>Track customer activity, rewards, and engagement history</li>
                            <li>Organize customer data for personalized communication and offers</li>
                            <li>Improve retention through targeted loyalty and membership management</li>
                            <li>Access valuable insights to better understand customer behavior</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerManagementFeatureBox1